import React from 'react'
import Shimmer from './Shimmer'
import SkeletonElement from './SkeletonElement'
import classNames from 'classnames'

function Skeletons(props) {
    return (
        <div className={classNames('skeletonWrapper', props.className)}>
            <SkeletonElement type={props.type} />
            <Shimmer />
        </div>
    )
}

export default Skeletons
